import PhotoSelectorHeader from './PhotoSelectorHeader';

export default PhotoSelectorHeader;
